import React, {Component} from 'react';
// style
import accordeonStyle from '../css/accordion.css';

class Accordion extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: this.props.isExpanded
        };
    }

    _handleExpandCollapse() {
        if (this.props.onClick) {
            this.props.onClick(typeof this.props.collapseKey === 'undefined' ? this.props.label : this.props.collapseKey);
        }
        if (this.props.initiator != undefined && this.props.initiator === 'LockedAccaBet') {
            this.props.onHandleAccordionOpenClose(!this.state.isExpanded);
        }
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({isExpanded: nextProps.isExpanded,});
    }

    render() {
        let accordionStyle = this.props.isSubAccordion ? accordeonStyle.accordeonSubTitle :
            this.state.isExpanded ? accordeonStyle.expandedAccordeon : accordeonStyle.accordeon;
        let accordionTitleStyle = this.props.isSubAccordion ? accordeonStyle.whiteTitle : accordeonStyle.title;
        let content = this.props.content;
        return (<div className={` ${accordionStyle}`}>
            <div id={this.props.id} className={` ${accordionTitleStyle}`} onClick={() => this._handleExpandCollapse()}>
                <div className={accordeonStyle.triangleContainer}>
                    <div className={this.state.isExpanded
                        ? this.props.isSubAccordion ? accordeonStyle.triangleDownSub : accordeonStyle.triangleDown
                        : this.props.isSubAccordion ? accordeonStyle.triangleRightSub : accordeonStyle.triangleRight}/>
                </div>
                <span className={accordeonStyle.accordeonLabel}>{this.props.label}</span>
            </div>
            <div className={this.state.isExpanded
                ? ''
                : accordeonStyle.closed}>
                {content}
            </div>
        </div>);
    }
}

export default Accordion;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/accordion.js